import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetFinixCardsRequestSchema } from "./getFinixCards.schema";

export const getFinixCards =
  (axios: IAxiosInstance) => async (params: TGetFinixCardsRequestSchema) => {
    const response = await axios.noRetry.get(
      "/api/business-cards/finix-cards",
      {
        params,
      }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Error getting Finix cards");
  };
